import Wrapper from './_views/Wrapper.vue';

const KernelPackageReturns = () => import('./_views/KernelPackageReturns.vue');
const KernelPackageReturn = () => import('./_views/KernelPackageReturn.vue');

const parentRouteConfig = {
  name: 'Package Returns',
  to: {
    name: 'packageReturns',
    query: {
      suffix: '',
      pageNum: '1',
    },
  },
};

export default {
  path: '/package-returns',
  component: Wrapper,
  children: [
    {
      path: '',
      name: 'packageReturns',
      component: KernelPackageReturns,
      meta: {
        title: 'Package Returns',
        navigation: {
          position: 2,
          name: 'Package Returns',
          icon: 'keyboard_return',
          specialQueries: ['suffix'],
          to: {
            name: 'packageReturns',
            query: {
              suffix: '',
              pageNum: '1',
            },
          },
        },
      },
    },
    {
      path: ':id',
      name: 'packageReturn',
      component: KernelPackageReturn,
      meta: {
        title: 'Returned Package',
        parent: parentRouteConfig,
      },
    },
  ],
};
